import { memoize } from 'lodash-es';
import { ProductSchema, SubjectSchema } from '@adobe/edex/ui/shared/types';
import { SubjectI18nLabel, SubjectID } from '@adobe/edex/ui/shared/constants';
import { TreeItem } from '@adobe/edex/ui/components/shared/tree-selector/tree-selector.types';
import { AllID } from '@adobe/edex/ui/components/search-page/search-filters/search-filters';

export const PRODUCT_CLASSIFICATIONS = Object.freeze([
  'i18n.product.classification.Images_and_Pictures',
  'i18n.product.classification.Video_and_Audio',
  'i18n.product.classification.Websites',

  'i18n.product.classification.Figures_and_Illustrations',
  'i18n.product.classification.Portfolios_and_Presentations',
  'i18n.product.classification.Apps',

  'i18n.product.classification.Documents',
  'i18n.product.classification.Productivity_and_Collaboration',
  'i18n.product.classification.Games',
  'i18n.product.classification.Digital_Experiences',
]);

// TODO: CCEDU-2811
export const classifyProducts = memoize(
  (items: ProductSchema[]) =>
    new Map(
      PRODUCT_CLASSIFICATIONS.map((classification) => [
        classification,
        items.filter((item) => item.classifications?.includes(classification)),
      ])
    )
);

export const sortSubjects = memoize((subjects: SubjectSchema[]): SubjectSchema[] =>
  subjects.sort((a, b) => (a.id === SubjectID.other ? 1 : a.i18nLabel.localeCompare(b.i18nLabel)))
);

export const sortAcademicLevels = memoize((academicLevel) =>
  academicLevel.sort((a, b) => (a.sortOrder < b.sortOrder ? -1 : 1))
);

export const subjects2treeItems = memoize((subjects: SubjectSchema[]): TreeItem[] => {
  subjects = sortSubjects(subjects);
  return [
    {
      id: AllID.subject,
      i18nLabel: SubjectI18nLabel.all,
    },
    ...subjects,
  ];
});
